import { BookmarkElement } from "../../models/bookmark-element.model";
import { Bookmark } from "../../models/bookmark.model";

/**
 * Controls application of related `BookmarkElement`s to their respective data fields.
 * Examples inlude: FiltersGroupBookmarkElementsOperator...
 */
export abstract class BookmarkElementsOperator {

	public abstract applyBookmarkElements(bookmarkElements: BookmarkElement[]): void;
	public abstract prepareBookmarkElements(bookmark: Bookmark): BookmarkElement[];
	
	/**
	 * 
	 * @param id Responsible for identifying multiple `BookmarkElement`s that this operator controls.
	 * @param onAllBookmarkElementsApplied Callback when all of the bookmark elements from a subset of operators assigned to bookmark component have been applied.
	 */
	constructor(
		public id: string,
		public onAllBookmarkElementsApplied?: () => void,
	) {}
}
